export default __webpack_public_path__ + "static/media/2291.ffe2459a.png";